<template>
    <div>
        <!-- <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div> -->

        <div class="row">
            <div class="col-sm-6 text-center borderLine">
                <br>
                <h4 class="text-uppercase height-50">
                    Start Learning
                </h4>
                <small class="text-uppercase">
                    Start Learning on WCEA Platform and obtain CPD points for the next 
                    <strong class="text-red">annual license year {{ year }}</strong>
                </small>
                <br><br>
                <button
                    class="btn btn-sm btn-success"
                    @click="goToWceaLearning()"
                    v-if="! isLoading"
                >
                    <i class="ni ni-send"></i> Click Here
                </button>
                <button 
                    class="btn btn-sm btn-success" disabled
                    v-if="isLoading"
                >
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Please Wait...
                </button>
                <br><br>
            </div>

            <div class="col-sm-6 text-center borderLine">
                <br>
                <h4 class="text-uppercase height-50">
                    My WCEA Certificates
                </h4>
                <small class="text-uppercase">
                    To download certifcates on WCEA Platform and update your CPD points for the next 
                    <strong class="text-red">annual license year {{ year }}</strong>                                    
                </small>
                <br><br>
                <router-link
                    to="/learning/certificates"
                    class="btn btn-sm btn-success"
                >
                    <i class="fa fa-share-square"></i> Click Here
                </router-link>

                <!-- <button
                    class="btn btn-sm btn-success"
                >
                    <i class="ni ni-send"></i> Click Here
                </button> -->
                <br><br>
            </div>
            <div class="col-sm-12">
                <hr>
            </div>
        </div>

        <div class="text-center" v-if='showErrorStatus'>
            <base-alert :type="errorType">
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
            </base-alert>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { mapGetters, mapActions } from 'vuex';
    import VueClipboard from 'vue-clipboard2'
    import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'
    import swal from 'sweetalert2';// import sweet alert

    Vue.use(VueClipboard)

    export default {
        directives: {
            'b-tooltip': BTooltipDirective
        },
        name: 'WceaStartPage',
        data() {
            return {
                year: (new Date().getFullYear() + 1),
                // isLoadingBlade: false,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isLoading: false
            }
        },
        computed: {
            ...mapGetters(['loadingBladeUrl']),
        },
        methods: {
            ...mapActions(['signOntoWcea']),
            goToWceaLearning() {
                this.isLoading = true;
                this.signOntoWcea().then((res) => {   
                    if(res.code == 200 && res.msg) {
                        const accessUrl = res.msg.accessLink;
                        return window.location.href = accessUrl;
                    } else {
                        this.isLoading = false;
                        swal.fire('Error Occurred!', res.msg, 'warning');
                        this.showAlert(res.msg, 'warning');
                    }                    
                }).
                catch(() => {
                    this.isLoading = false;
                    this.showErrorStatus = true;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            showAlert(msg, type) {
                this.$notify({
                    type: type,
                    title: msg
                })
            },
        }
    };
</script>
<style scoped>
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>
